import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './queries';
import { User } from 'types';

interface UsersResponse {
  success: boolean;
  users: User[];
}

interface UserResponse {
  success: boolean;
  user?: User;
}

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: axiosBaseQuery({
    baseUrl: import.meta.env.VITE_APP_BASE_URL as string,
  }),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    // Get users in current workspace (uses X-Workspace-ID header)
    getUsers: builder.query<User[], void>({
      query: () => ({ 
        url: '/v1/users/', 
        method: 'get'
      }),
      transformResponse: (response: UsersResponse) => response.users,
      providesTags: ['User'],
    }),
    
    // Get current user profile
    getCurrentUser: builder.query<User, void>({
      query: () => ({ 
        url: '/v1/auth/me/', 
        method: 'get' 
      }),
      providesTags: ['User'],
    }),
    
    // Update current user profile
    updateCurrentUser: builder.mutation<User, Partial<User>>({
      query: (data) => ({ 
        url: '/v1/auth/me/', 
        method: 'patch', 
        data 
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetCurrentUserQuery,
  useUpdateCurrentUserMutation,
} = userApi;
